import React from 'react'

export const ModalBody = ({ children }) => {
  return <section className="modal-card-body">{children}</section>
}
